import React from 'react';
import { ClockIcon, ExclamationTriangleIcon } from "@heroicons/react/20/solid";

export default function FileStatusIndicator({ status }) {
  if (status === "PENDING" || status === "PROCESSING") {
    return <ClockIcon className="ml-1 h-4 w-4 text-warning" />;
  }
  if (status === "FAILED") {
    return <ExclamationTriangleIcon className="ml-1 h-4 w-4 text-danger" />;
  }
  return null;
} 